export default __webpack_public_path__ + "resources/icons/d112-e50f.webp";